import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import { createAsyncActionReducer } from "./api";
import { fetchSpeakers } from "../actions/engine";
const data = createReducer({}).handleAction(fetchSpeakers.success, (state, action) => (Object.assign(Object.assign({}, state), { speakers: action.payload })));
const requests = combineReducers({
    fetchSpeakers: createAsyncActionReducer([fetchSpeakers])
});
export default combineReducers({ data, requests });
